/**
 * Deck parse progress tracking: schema contract, phase constants, and types.
 *
 * Progress is display-only and must never invalidate the marker that carries it.
 */

import { z } from "zod";

export const DECK_PARSE_PHASES = ["reading", "summarising", "finishing"] as const;
export type DeckParsePhase = (typeof DECK_PARSE_PHASES)[number];

export const DeckParseProgressSchema = z.object({
  phase: z.enum(DECK_PARSE_PHASES),
  batchesDone: z.number().int().nonnegative(),
  batchesTotal: z.number().int().nonnegative(),
  attemptStartedAt: z.string(), // ISO; one value per step execution
  updatedAt: z.string(),
});

export type DeckParseProgress = z.infer<typeof DeckParseProgressSchema>;
export type DeckParseProgressCounts = Pick<DeckParseProgress, "phase" | "batchesDone" | "batchesTotal">;
